import { css } from 'lit'

export default css`
    .container {
        display: flex;
        gap: 16px;
    }
    .container > * {
        flex: 1;
    }
    .delete {
        color: var(--grey3);
    }
    .container .input[readonly][type='text'] {
        background: var(--disabled);
        color: #9cabb9;
    }
    .container .input[invalid][type='text'] {
        border-color: var(--negative);
    }
`
